// axios 发送ajax请求
import request from '@/utils/request'

export default {

  // 查询商品列表
  add(xuanchuan) {
    return request({
      url: '/api/xc/add',
      method: 'post',
      data: xuanchuan
    })
  },

  // 查询物品列表
  searchThings(currentPage, pageSize, searchParams) {
    return request({
      url: '/api/thing-info/list/'+currentPage+'/'+pageSize,
      method: 'get',
      params: {
        ...searchParams
      }
    })
  },

  // 查询物品列表
  searchXC(currentPage, pageSize, searchParams) {
    return request({
      url: '/api/xc/list/'+currentPage+'/'+pageSize,
      method: 'get',
      params: {
        ...searchParams
      }
    })
  },

  // 删除物品接口
  updateThing(pId) {
    return request({
      url: `/api/xc/${pId}`,
      method: 'post'
    })
  },
  add1(xuanchuan) {
    return request({
      url: '/api/xc/add1',
      method: 'post',
      data: xuanchuan
    })
  },

  // 查询物品列表
  searchThings1(currentPage, pageSize, searchParams) {
    return request({
      url: '/api/thing-info/list1/'+currentPage+'/'+pageSize,
      method: 'get',
      params: {
        ...searchParams
      }
    })
  },

  // 查询物品列表
  searchXC1(currentPage, pageSize, searchParams) {
    return request({
      url: '/api/xc/list1/'+currentPage+'/'+pageSize,
      method: 'get',
      params: {
        ...searchParams
      }
    })
  },

  // 删除物品接口
  updateThing1(pId) {
    return request({
      url: `/api/xc/1/${pId}`,
      method: 'post'
    })
  }
}